import React from 'react'
import listhoc from '../Offers/listhoc';
import { orders_api } from '../../actions/http';
import {Address} from "./order";
import usericon from "../../assets/images/user.png";
import LazyImg from '../lazyimg';
import moment from "moment";
import StarRate from './starrating';

const StoreOrder = ({id, rating, order_id, deliverydetails, status, created_on, employee_assigned}) => (
    <div className="order">
        <div className="flex-between m-b-10">
            <div className="tripid">Trip Id: {order_id}</div>
            <div className={`order-status-${status.id}`}>{status.name}</div>
        </div>
        {
            employee_assigned &&
            <div className="delivery-person-details">
                <div className="row">
                    <div className="col-md-6  p-b-10">
                        <h5 className="addr-head">Delivery person details</h5>
                        <div className="row">
                            <div className="col-md-2 p-b-10">
                                <LazyImg className="employeeimg" src={employee_assigned.profile_pic || usericon} alt={employee_assigned.first_name} />
                            </div>
                            <div className="col-md-10  p-b-10">
                                <div>
                                    <p>{employee_assigned.first_name}</p>
                                    <a className="common-color" href={`tel:${employee_assigned.username}`}>{employee_assigned.username}</a> 
                                </div>
                            </div>
                        </div>
                    </div>
                    {status.id === 5 && <div className="col-md-6  p-b-10">
                        <h5 className="addr-head">Rate your order</h5>
                        <div className="star-rating">
                            <StarRate id={id} rating={rating} />
                        </div>
                    </div>}
                </div>
            </div>
        }
        <div className="row">
            {deliverydetails &&
            <div className="col-md-6 dashed-border-left  m-b-10">
                <Address heading="Delivery details" address={deliverydetails}/>
            </div>}
        </div>
        <div className="flex-between">
            <div>
                <span className="m-r-10">Created on: <b>{moment(created_on).format('lll')}</b></span>
            </div>
            <div>

            </div>
        </div>
    </div>
)

export const UpcomingOrders = listhoc(StoreOrder, "ORDERLIST_UPCOMING" , "orderlist_upcoming", orders_api + `?is_completed=false&limit=12`);

export const CompletedOrders = listhoc(StoreOrder, "ORDERLIST_COMPLETED" , "orderlist_completed", orders_api + `?is_completed=true&limit=12`);

export default StoreOrder
